import { useMemo } from 'react';

import Button from 'components/shared/Button/Button';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import DateInputPicker from 'components/shared/DateInputPicker/DateInputPicker';
import Icon from 'components/shared/Icon/Icon';
import Input from 'components/shared/Input/Input';
import SegmentedControl from 'components/shared/SegmentedControl/SegmentedControl';
import Select from 'components/shared/Select/Select';
import Typography from 'components/shared/Typography/Typography';
import Hint from 'components/shared/shared/Hint';

const PreAuthInputsPreview = () => {
  const previewDate = useMemo(() => new Date(), []);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-3">
        <div className="flex items-start gap-3">
          <Input label="Cardholder's name" value="John Doe" className="flex-1" disabled />
          <DateInputPicker
            label="Date"
            parentClassName="flex-1"
            disabled
            value={previewDate}
            labelClassName="text-neutral-400"
            iconIsRight
            isClearable={false}
          />
        </div>
        <Input label="Address 1" value="Apt 4B" className="flex-1" disabled />
        <Input label="Address 2" value="Apt 4B" className="flex-1" disabled />
        <Select
          label="City"
          className="flex-1"
          disabled
          value={{ label: 'New York City', value: 'new_york_city' }}
          options={[{ label: 'New York City', value: 'new_york_city' }]}
        />
        <Select
          label="State"
          className="flex-1"
          disabled
          value={{ label: 'New York', value: 'NY' }}
          options={[{ label: 'New York', value: 'NY' }]}
        />
        <Input label="Zip Code" value="10001" className="flex-1" disabled />
        <Input label="Card number" value="1234 1234 1234 1234" className="flex-1" disabled />
        <div className="flex items-start gap-3">
          <Input label="Exp" value="MM/YY" className="flex-1" disabled />
          <Input label="CVC" value="123" className="flex-1" disabled />
        </div>
      </div>
      <div className="flex items-start gap-2">
        <Checkbox isChecked disabled />
        <Typography variant="p" size="small" color="neutral-400">
          I authorize secure storage and use of my card information according to the terms above for
          approved healthcare transactions, refunds, and automatic updates.
        </Typography>
      </div>
      <div className="flex flex-col gap-4">
        <SegmentedControl
          items={[
            { value: 'draw', label: 'Draw signature' },
            { value: 'type', label: 'Type signature' }
          ]}
          disabled
        />
        <div className="flex flex-col gap-1">
          <div className="flex flex-1 items-center">
            <Typography
              variant="label"
              size="medium"
              weight="medium"
              color="neutral-400"
              parentClassName="flex-1">
              Cardholder signature
            </Typography>
            <div className="flex items-center gap-3">
              <Icon icon="undo-linear" />
              <Icon icon="redo-linear" />
              <Button text="Clear" variant="link" size="small" color="neutral" disabled />
            </div>
          </div>
          <div className="flex h-[200px] flex-col items-center justify-center gap-3 rounded-md border border-dashed border-neutral-400 bg-neutral-25 p-5">
            <span className="text-2xl leading-[48px] text-neutral-300">Sign here</span>
          </div>
          <Hint
            icon="info-filled"
            hint="By signing, I acknowledge that this electronic signature is legally binding and equivalent to my handwritten signature."
            className="items-start"
            disabled
          />
        </div>
      </div>
    </div>
  );
};

export default PreAuthInputsPreview;
